/**
 * 검색 실행 엔진(LeftAiPanel)을 화면 없이 띄워 둔다 — 휴대폰 화면용(2026-10-02).
 *
 * 데스크톱에서는 사이드바가 이 엔진을 숨겨 품고 있어, 위·가운데 검색바 제출(pendingSearch)을 받아 실행한다.
 * 휴대폰에서는 사이드바를 그리지 않아 엔진이 없었다 — 검색을 눌러도 아무 일이 없던 이유.
 * 그래서 휴대폰 셸에서는 이 컴포넌트가 같은 엔진을 같은 문맥 연결로 띄운다(둘이 동시에 뜨지 않게 App 이 고른다).
 */
import React from "react";
import LeftAiPanel from "./LeftAiPanel";
import { useAuditSearch } from "./AuditSearchContext";

export default function SearchEngineHost() {
  const { setSearchContext, setFocusedCase, setGoogleImageQ, setSearchResults, setSubdivisionPreview } = useAuditSearch();
  return (
    <div className="hidden" aria-hidden="true" style={{ display: "none" }}>
      <LeftAiPanel
        currentChapter={null}
        onAnyAction={() => {}}
        onSearchContextChange={setSearchContext}
        onFocusCase={setFocusedCase}
        onGoogleImageOpen={setGoogleImageQ}
        onSearchResults={setSearchResults}
        onSubdivisionPreview={setSubdivisionPreview}
      />
    </div>
  );
}
